import AgentDiscoveryController from "./agent_discovery_controller"

export default class extends AgentDiscoveryController {
  // Action name used in the view's save button
  saveConnector() {
    return this.save()
  }

  renderPreview(config) {
    if (!this.hasPreviewContentTarget) return

    let html = `
      <div class="space-y-3">
        <div>
          <span class="text-xs font-semibold text-base-content/60 uppercase">Name</span>
          <p class="font-medium">${this.escapeHtml(config.name || 'Unnamed')}</p>
        </div>
        <div>
          <span class="text-xs font-semibold text-base-content/60 uppercase">URL</span>
          <p class="text-sm font-mono break-all">${this.escapeHtml(config.url || '')}</p>
        </div>
        <div class="flex gap-2">
          <div>
            <span class="text-xs font-semibold text-base-content/60 uppercase">Type</span>
            <p><span class="badge badge-sm badge-secondary">${this.escapeHtml(config.connector_type || 'website')}</span></p>
          </div>
          <div>
            <span class="text-xs font-semibold text-base-content/60 uppercase">Page Type</span>
            <p><span class="badge badge-sm badge-info">${this.escapeHtml(config.page_type || config.extraction_config?.page_type || 'unknown')}</span></p>
          </div>
        </div>
    `

    if (config.geographic_area) {
      html += `
        <div>
          <span class="text-xs font-semibold text-base-content/60 uppercase">Geographic Area</span>
          <p class="text-sm">${this.escapeHtml(config.geographic_area)}</p>
        </div>
      `
    }

    if (config.extraction_config?.extraction_prompt) {
      html += `
        <div>
          <span class="text-xs font-semibold text-base-content/60 uppercase">Extraction Prompt</span>
          <p class="text-xs bg-base-200 rounded p-2 mt-1 max-h-32 overflow-y-auto">${this.escapeHtml(config.extraction_config.extraction_prompt)}</p>
        </div>
      `
    }

    if (config.sample_data && config.sample_data.length > 0) {
      html += `
        <div>
          <span class="text-xs font-semibold text-base-content/60 uppercase">Sample Data (${config.sample_data.length} records)</span>
          <pre class="text-xs bg-base-200 rounded p-2 mt-1 overflow-x-auto max-h-48">${this.escapeHtml(JSON.stringify(config.sample_data[0], null, 2))}</pre>
        </div>
      `
    }

    if (config.summary) {
      html += `
        <div>
          <span class="text-xs font-semibold text-base-content/60 uppercase">Summary</span>
          <p class="text-sm">${this.escapeHtml(config.summary)}</p>
        </div>
      `
    }

    html += '</div>'
    this.previewContentTarget.innerHTML = html
  }
}
